function NewElementsToolbar({template, currentSlide, carousel, setCarousel}){
  const addElement = (type) => {
    template?.addElement(type, template, carousel, currentSlide, setCarousel);
  }

  return (
    <div className="px-4 py-5 space-y-5 sm:px-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900">Elements</h2>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => addElement("image")}
          className="flex flex-col items-center gap-2 p-3 text-sm font-semibold text-gray-700 transition-all duration-150 bg-white rounded-lg hover:bg-gray-100 ring-1 ring-inset ring-gray-900/10"
        >
          <svg
            aria-hidden="true"
            className="w-5 h-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <path d="M144,96a16,16,0,1,1,16,16A16,16,0,0,1,144,96Zm92-40V200a20,20,0,0,1-20,20H40a20,20,0,0,1-20-20V56A20,20,0,0,1,40,36H216A20,20,0,0,1,236,56ZM44,60v79.72l33.86-33.86a20,20,0,0,1,28.28,0L147.31,147l17.18-17.17a20,20,0,0,1,28.28,0L212,149.09V60Zm0,136H162.34L92,125.66l-48,48Zm168,0V183l-33.37-33.37L164.28,164l32,32Z"></path>
          </svg>
          Add Image
        </button>
        <button
          onClick={() => addElement("text")}
          type="button"
          className="flex flex-col items-center gap-2 p-3 text-sm font-semibold text-gray-700 transition-all duration-150 bg-white rounded-lg hover:bg-gray-100 ring-1 ring-inset ring-gray-900/10"
        >
          <svg
            aria-hidden="true"
            className="w-5 h-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <path d="M112,36a12,12,0,0,0-12,12V60H24A20,20,0,0,0,4,80v96a20,20,0,0,0,20,20h76v12a12,12,0,0,0,24,0V48A12,12,0,0,0,112,36ZM28,172V84h72v88ZM252,80v96a20,20,0,0,1-20,20H152a12,12,0,0,1,0-24h76V84H152a12,12,0,0,1,0-24h80A20,20,0,0,1,252,80ZM88,112a12,12,0,0,1-12,12v20a12,12,0,0,1-24,0V124a12,12,0,0,1,0-24H76A12,12,0,0,1,88,112Z"></path>
          </svg>
          Add Textbox
        </button>
      </div>
    </div>
  )
}

export default NewElementsToolbar
